// helpers/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react'; // Added useCallback

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [studentId, setStudentId] = useState(null);
  const [studentName, setStudentName] = useState(null);
  const [studentEmail, setStudentEmail] = useState(null);
  const [sessionToken, setSessionToken] = useState(null);
  const [collegeId, setCollegeId] = useState(null);         // <-- NEW STATE
  const [enrollmentId, setEnrollmentId] = useState(null);   // <-- NEW STATE
  const [academicCourse, setAcademicCourse] = useState(null); // <-- NEW STATE
  const [authLoaded, setAuthLoaded] = useState(false);

  // Unique token key (ensure this matches what you use in StudentLogin.js)
  const TOKEN_KEY = 'H7Z4L9VD2XK5JW8QRRS7';

  // Load from localStorage on first mount
  useEffect(() => {
    const storedStudentId = localStorage.getItem('student_id');
    const storedStudentName = localStorage.getItem('student_first_name');
    const storedStudentEmail = localStorage.getItem('student_email');
    const storedToken = localStorage.getItem(TOKEN_KEY);
    const storedCollegeId = localStorage.getItem('college_id');         // <-- LOAD NEW ITEM
    const storedEnrollmentId = localStorage.getItem('enrollment_id');   // <-- LOAD NEW ITEM
    const storedAcademicCourse = localStorage.getItem('academic_course'); // <-- LOAD NEW ITEM

    if (storedStudentId) setStudentId(parseInt(storedStudentId)); // Parse to number
    if (storedStudentName) setStudentName(storedStudentName);
    if (storedStudentEmail) setStudentEmail(storedStudentEmail);
    if (storedToken) setSessionToken(storedToken);
    if (storedCollegeId) setCollegeId(parseInt(storedCollegeId)); // Parse to number
    if (storedEnrollmentId) setEnrollmentId(parseInt(storedEnrollmentId)); // Parse to number
    if (storedAcademicCourse) setAcademicCourse(storedAcademicCourse); // <-- SET NEW STATE

    setAuthLoaded(true);
  }, [TOKEN_KEY]); // Add TOKEN_KEY to dependencies

  // Sync localStorage when values change
  useEffect(() => {
    studentId
      ? localStorage.setItem('student_id', studentId)
      : localStorage.removeItem('student_id');

    studentName
      ? localStorage.setItem('student_first_name', studentName)
      : localStorage.removeItem('student_first_name');

    studentEmail
      ? localStorage.setItem('student_email', studentEmail)
      : localStorage.removeItem('student_email');

    sessionToken
      ? localStorage.setItem(TOKEN_KEY, sessionToken)
      : localStorage.removeItem(TOKEN_KEY);

    collegeId
      ? localStorage.setItem('college_id', collegeId)         // <-- SAVE NEW ITEM
      : localStorage.removeItem('college_id');

    enrollmentId
      ? localStorage.setItem('enrollment_id', enrollmentId)   // <-- SAVE NEW ITEM
      : localStorage.removeItem('enrollment_id');

    academicCourse
      ? localStorage.setItem('academic_course', academicCourse) // <-- SAVE NEW ITEM
      : localStorage.removeItem('academic_course');

  }, [studentId, studentName, studentEmail, sessionToken, collegeId, enrollmentId, academicCourse, TOKEN_KEY]); // Add new states and TOKEN_KEY to dependencies

  const login = useCallback((id, name, email, token, colId, enrId, course) => { // <-- NEW PARAMETERS
    setStudentId(id);
    setStudentName(name);
    setStudentEmail(email);
    setSessionToken(token);
    setCollegeId(colId);         // <-- SET NEW STATE
    setEnrollmentId(enrId);     // <-- SET NEW STATE
    setAcademicCourse(course);  // <-- SET NEW STATE

    // Immediately save to localStorage as well for quick access (though useEffect will eventually sync)
    localStorage.setItem('student_id', id);
    localStorage.setItem('student_first_name', name);
    localStorage.setItem('student_email', email);
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem('college_id', colId);
    localStorage.setItem('enrollment_id', enrId);
    localStorage.setItem('academic_course', course);
  }, [TOKEN_KEY]);
console.log("acdemic Course",academicCourse)
  const logout = useCallback(() => { // Using useCallback for logout as well
    // It's generally better to remove specific items than clear all localStorage/sessionStorage
    // if other parts of your app might use them.
    localStorage.removeItem('student_id');
    localStorage.removeItem('student_first_name');
    localStorage.removeItem('student_email');
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('college_id');         // <-- REMOVE NEW ITEM
    localStorage.removeItem('enrollment_id');       // <-- REMOVE NEW ITEM
    localStorage.removeItem('academic_course');     // <-- REMOVE NEW ITEM
    localStorage.removeItem('darkMode');
    localStorage.removeItem('theme');
    sessionStorage.clear(); // If you want to clear sessionStorage, keep this.

    document.documentElement.classList.remove('dark');

    setStudentId(null);
    setStudentName(null);
    setStudentEmail(null);
    setSessionToken(null);
    setCollegeId(null);         // <-- CLEAR NEW STATE
    setEnrollmentId(null);     // <-- CLEAR NEW STATE
    setAcademicCourse(null);  // <-- CLEAR NEW STATE
  }, [TOKEN_KEY]);


  return (
    <AuthContext.Provider
      value={{
        studentId,
        setStudentId,
        studentName,
        setStudentName,
        studentEmail,
        setStudentEmail,
        sessionToken,
        setSessionToken,
        collegeId,          // <-- EXPOSE NEW STATE
        setCollegeId,       // You might not need a setter for this if only login sets it
        enrollmentId,       // <-- EXPOSE NEW STATE
        setEnrollmentId,    // You might not need a setter for this if only login sets it
        academicCourse,     // <-- EXPOSE NEW STATE
        setAcademicCourse,  // You might not need a setter for this if only login sets it
        login,
        logout,
        authLoaded,
      }}
    >
      {authLoaded ? children : null}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);